import { DatePicker } from 'antd';
import styled from 'styled-components';

const DatepickerStyled = styled(DatePicker)`
  width: 100%;
  height: 40px;
`;

export default DatepickerStyled;
